import React, { Component, useState } from 'react';
import { bool, string } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Field, Form as FinalForm } from 'react-final-form';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import { ensureCurrentUser } from '../../util/data';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import {
  isTooManyEmailVerificationRequestsError,
  isUploadImageOverLimitError,
} from '../../util/errors';
import arrayMutators from 'final-form-arrays';
import { ReactComponent as EditIcon } from '../../assets/svg/editPen.svg';
import { saveEmailError } from '../../containers/ContactDetailsPage/ContactDetailsPage.duck';

import {
  Form,
  Avatar,
  Button,
  ImageFromFile,
  IconSpinner,
  FieldTextInput,
  FieldAddress,
  FieldPhoneNumberInputWithDialCode,
  FieldPerferredLang,
  FieldWorkerJobCategory,
  CustomRadioButton,
  FieldDateInput,
  FieldCheckbox,
  ChangeEmailModal,
  FieldDisabledInput,
  NamedLink,
} from '../../components';

import css from './ProfileSettingsForm.module.css';
import { deleteProfileImage } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import {
  drivingLicenseOptions,
  workerAllowedOptions,
  age16PlusOptions,
  minimumAgeRequired,
} from '../../marketplace-custom-config';
import moment from 'moment';
const textfield = 'textfield';
const errorTextField = 'errorTextField';
const ACCEPT_IMAGES = 'image/*';
const UPLOAD_CHANGE_DELAY = 2000; // Show spinner so that browser has time to load img srcset
const workagredOnTerms = 'yes';
import { sendVerificationEmailError } from '../../ducks/user.duck';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
const SHOW_EMAIL_SENT_TIMEOUT = 2000;
class WorkerProfileSettingsFormComponent extends Component {
  constructor(props) {
    super(props);

    this.uploadDelayTimeoutId = null;
    this.state = { uploadDelay: false };
    this.submittedValues = {};
    this.formApi = null;
  }

  componentDidUpdate(prevProps) {
    // Upload delay is additional time window where Avatar is added to the DOM,
    // but not yet visible (time to load image URL from srcset)
    if (prevProps.uploadInProgress && !this.props.uploadInProgress) {
      this.setState({ uploadDelay: true });
      this.uploadDelayTimeoutId = window.setTimeout(() => {
        this.setState({ uploadDelay: false });
      }, UPLOAD_CHANGE_DELAY);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.uploadDelayTimeoutId);
  }

  handleDrivingLicenseChange = value => {
    this.formApi.change('drivingLicense', value);
  };
  render() {
    return (
      <FinalForm
        {...this.props}
        mutators={{ ...arrayMutators }}
        render={fieldRenderProps => {
          const {
            className,
            currentUser,
            handleSubmit,
            intl,
            invalid,
            onImageUpload,
            pristine,
            profileImage,
            rootClassName,
            updateInProgress,
            updateProfileError,
            uploadImageError,
            uploadInProgress,
            form,
            values,
            onUpdateProfile,
            onUpdateCustomProfile,
            initialValues,
            userNativeLang,
            sendVerificationEmailError,
            sendVerificationEmailInProgress,
            onManageDisableScrolling,
            onSubmitContactDetails,
            onResendVerificationEmail,
            history,
            tab,
          } = fieldRenderProps;
          const { workerAgrement } = values;
          const [showVerificationEmailSentMessage, setShowVerificationEmailSentMessage] = useState(
            false
          );
          const [showEmailChangeModal, setShowEmailChangeModal] = useState(false);
          this.formApi = form;
          const {
            jobCategories,
            drivingLicense,
            workerAllowed,
            age16Plus,
            email,
            firstName,
            lastName,
          } = values;

          const user = ensureCurrentUser(currentUser);
          // const { emailVerified, pendingEmail } = user.attributes;
          const { email: currentEmail, emailVerified, pendingEmail, profile } = user.attributes;
          const isProfileVerified = !!profile?.metadata?.isProfileVerified;

          // email

          // has the email changed
          const emailChanged = currentEmail !== email;

          // Company name
          const companyNameLabel = intl.formatMessage({
            id: 'ProfileSettingsForm.companyNameLabel',
          });
          const companyNamePlaceholder = intl.formatMessage({
            id: 'ProfileSettingsForm.companyNamePlaceholder',
          });
          const companyNameRequiredMessage = intl.formatMessage({
            id: 'ProfileSettingsForm.companyNameRequired',
          });
          const companyNameRequired = validators.required(companyNameRequiredMessage);

          // Industry
          const industryLabel = intl.formatMessage({
            id: 'ProfileSettingsForm.industryLabel',
          });
          const industryPlaceholder = intl.formatMessage({
            id: 'ProfileSettingsForm.industryPlaceholder',
          });
          const industryRequiredMessage = intl.formatMessage({
            id: 'ProfileSettingsForm.industryRequired',
          });
          const industryRequired = validators.required(industryRequiredMessage);

          // First name
          const firstNameLabel = intl.formatMessage({
            id: 'ProfileSettingsForm.firstNameLabel',
          });
          const firstNamePlaceholder = intl.formatMessage({
            id: 'ProfileSettingsForm.firstNamePlaceholder',
          });
          const firstNameRequiredMessage = intl.formatMessage({
            id: 'ProfileSettingsForm.firstNameRequired',
          });
          const firstNameRequired = validators.required(firstNameRequiredMessage);
          // Last name
          const lastNameLabel = intl.formatMessage({
            id: 'ProfileSettingsForm.lastNameLabel',
          });
          const lastNamePlaceholder = intl.formatMessage({
            id: 'ProfileSettingsForm.lastNamePlaceholder',
          });
          const lastNameRequiredMessage = intl.formatMessage({
            id: 'ProfileSettingsForm.lastNameRequired',
          });
          const lastNameRequired = validators.required(lastNameRequiredMessage);
          // phone number
          const phoneNumberLabel = intl.formatMessage({
            id: 'SignupForm.phoneNumbeLabel',
          });
          const phoneNumberPlaceholder = intl.formatMessage({
            id: 'SignupForm.phoneNumbePlaceholder',
          });
          const phoneNumberRequiredMessage = intl.formatMessage({
            id: 'SignupForm.phoneNumbeRequired',
          });
          const phoneNumberRequired = validators.phoneNumberRequired(phoneNumberRequiredMessage);
          // worker address
          const addressLabel = intl.formatMessage({
            id: 'SignupForm.workerAdrressLabel',
          });
          const addressPlaceholder = intl.formatMessage({
            id: 'SignupForm.workerAdrressPlaceholder',
          });
          const postalLabel = intl.formatMessage({
            id: 'SignupForm.workerPostalLabel',
          });
          const postalPlaceholder = intl.formatMessage({
            id: 'SignupForm.workerPostalPlaceholder',
          });
          const addressRequiredMessage = intl.formatMessage({
            id: 'SignupForm.workerAdrressRequired',
          });
          // email
          const emailLabel = intl.formatMessage({
            id: 'ContactInformationForm.emailLabel',
          });
          const emailPlaceholder = intl.formatMessage({
            id: 'ContactInformationForm.emailPlaceholder',
          });
          const emailRequiredMessage = intl.formatMessage({
            id: 'ContactInformationForm.emailRequired',
          });
          const emailExistMessage = intl.formatMessage({
            id: 'ContactInformationForm.emailExist',
          });
          const emailRequired = validators.required(emailRequiredMessage);
          const emailInvalidMessage = intl.formatMessage({
            id: 'ContactInformationForm.emailInvalid',
          });
          const emailValid = validators.emailFormatValid(emailInvalidMessage);
          const addressRequired = validators.addressRequired(addressRequiredMessage);
          const emailExist = validators.isEmailExist(emailExistMessage);

          const emailValidator = validators.composeValidators(
            emailRequired,
            emailValid,
            emailExist
          );
          const tooManyVerificationRequests = isTooManyEmailVerificationRequestsError(
            sendVerificationEmailError
          );
          const handleResendVerificationEmail = () => {
            //  this.setState({ showVerificationEmailSentMessage: true });
            setShowVerificationEmailSentMessage(true);

            onResendVerificationEmail().then(() => {
              // show "verification email sent" text for a bit longer.
              const emailSentTimeoutId = window.setTimeout(() => {
                setShowVerificationEmailSentMessage(false);
              }, SHOW_EMAIL_SENT_TIMEOUT);
              return () => {
                window.clearTimeout(emailSentTimeoutId);
              };
            });
          };
          let resendEmailMessage = null;
          if (tooManyVerificationRequests) {
            resendEmailMessage = (
              <span className={css.tooMany}>
                <FormattedMessage id="ContactDetailsForm.tooManyVerificationRequests" />
              </span>
            );
          } else if (sendVerificationEmailInProgress || showVerificationEmailSentMessage) {
            resendEmailMessage = (
              <span className={css.emailSent}>
                <FormattedMessage id="ContactDetailsForm.emailSent" />
                {/* <FormattedMessage id="ContactDetailsForm.tooManyVerificationRequests" /> */}
              </span>
            );
          } else {
            resendEmailMessage = (
              <span
                className={css.helperLink}
                onClick={handleResendVerificationEmail}
                role="button"
              >
                <FormattedMessage id="ContactDetailsForm.resendEmailVerificationText" />
              </span>
            );
          }
          let emailVerifiedInfo = null;

          if (emailVerified && !pendingEmail && !emailChanged) {
            // Current email is verified and there's no pending unverified email
            emailVerifiedInfo = (
              <span className={css.emailVerified}>
                <FormattedMessage id="ContactDetailsForm.emailVerified" />
              </span>
            );
          } else if (!emailVerified && !pendingEmail) {
            // Current email is unverified. This is the email given in sign up form

            emailVerifiedInfo = (
              <span className={css.emailUnverified}>
                <FormattedMessage
                  id="ContactDetailsForm.emailUnverified"
                  values={{ resendEmailMessage }}
                />
              </span>
            );
          } else if (pendingEmail) {
            // Current email has been tried to change, but the new address is not yet verified

            const pendingEmailStyled = <span className={css.emailStyle}>{pendingEmail}</span>;
            const pendingEmailCheckInbox = (
              <span className={css.checkInbox}>
                <FormattedMessage
                  id="ContactDetailsForm.pendingEmailCheckInbox"
                  values={{ pendingEmail: pendingEmailStyled }}
                />
              </span>
            );

            emailVerifiedInfo = (
              <span className={css.pendingEmailUnverified}>
                <FormattedMessage
                  id="ContactDetailsForm.pendingEmailUnverified"
                  values={{
                    pendingEmailCheckInbox,
                    resendEmailMessage,
                  }}
                />
              </span>
            );
          }

          // companyDesc
          const companyDescLabel = intl.formatMessage({
            id: 'ProfileSettingsForm.companyDescLabel',
          });
          const companyDescPlaceholder = intl.formatMessage({
            id: 'ProfileSettingsForm.companyDescPlaceholder',
          });
          //birthdate select
          const birthdateLabel = intl.formatMessage({
            id: 'SignupForm.birthDateSelectLabel',
          });
          const birthdatePlaceholder = intl.formatMessage({
            id: 'SignupForm.birthDateSelectPlaceholder',
          });
          const birthdateRequiredMessage = intl.formatMessage(
            {
              id: 'SignupForm.birthDateSelectRequired',
            },
            { minValue: minimumAgeRequired }
          );
          const birthdateValidator = validators.composeValidators(
            validators.required(birthdateRequiredMessage),
            validators.isDateAboveMinValue(birthdateRequiredMessage, minimumAgeRequired)
          );
          // worker aggrement
          const workerAgrementLabel = intl.formatMessage({
            id: 'SignupForm.workerAgrementLabel',
          });

          const uploadingOverlay =
            uploadInProgress || this.state.uploadDelay ? (
              <div className={css.uploadingImageOverlay}>
                <IconSpinner />
              </div>
            ) : null;

          const hasUploadError = !!uploadImageError && !uploadInProgress;
          const errorClasses = classNames({
            [css.avatarUploadError]: hasUploadError,
          });
          const transientUserProfileImage = profileImage.uploadedImage || user.profileImage;
          const transientUser = {
            ...user,
            profileImage: transientUserProfileImage,
          };

          // Ensure that file exists if imageFromFile is used
          const fileExists = !!profileImage.file;
          const fileUploadInProgress = uploadInProgress && fileExists;
          const delayAfterUpload = profileImage.imageId && this.state.uploadDelay;
          const imageFromFile =
            fileExists && (fileUploadInProgress || delayAfterUpload) ? (
              <ImageFromFile
                id={profileImage.id}
                className={errorClasses}
                rootClassName={css.uploadingImage}
                aspectRatioClassName={css.squareAspectRatio}
                file={profileImage.file}
              >
                {uploadingOverlay}
              </ImageFromFile>
            ) : null;

          // Avatar is rendered in hidden during the upload delay
          // Upload delay smoothes image change process:
          // responsive img has time to load srcset stuff before it is shown to user.
          const avatarClasses = classNames(errorClasses, css.avatar, {
            [css.avatarInvisible]: this.state.uploadDelay,
          });
          const avatarComponent =
            !fileUploadInProgress && profileImage.imageId ? (
              <Avatar
                className={avatarClasses}
                renderSizes="(max-width: 767px) 96px, 240px"
                user={transientUser}
                disableProfileLink
              />
            ) : null;

          const chooseAvatarLabel =
            profileImage.imageId || fileUploadInProgress ? (
              <>
                <div className={css.avatarContainer}>
                  {imageFromFile}
                  {avatarComponent}
                  {/* <div className={css.changeAvatar}>
                    <FormattedMessage id="ProfileSettingsForm.changeAvatar" />
                  </div> */}
                </div>
                {/* <button onClick={() => onUpdateProfile({ profileImageId: null })}>Remove</button> */}
              </>
            ) : (
              <div className={css.avatarPlaceholder}>
                <div className={css.avatarPlaceholderText}>
                  <FormattedMessage id="ProfileSettingsForm.addYourProfilePicture" />
                </div>
                <div className={css.avatarPlaceholderTextMobile}>
                  <FormattedMessage id="ProfileSettingsForm.addYourProfilePictureMobile" />
                </div>
              </div>
            );

          const submitError = updateProfileError ? (
            <div className={css.error}>
              <FormattedMessage id="ProfileSettingsForm.updateProfileFailed" />
            </div>
          ) : null;
          const [remove, setRemove] = useState(true);

          const classes = classNames(rootClassName || css.root, className);
          const submitInProgress = updateInProgress;
          const submittedOnce = Object.keys(this.submittedValues).length > 0;
          const pristineSinceLastSubmit = submittedOnce && isEqual(values, this.submittedValues);
          const submitDisabled =
            invalid ||
            (pristine && !(initialValues.profileImage === null && profileImage.id !== null)) ||
            pristineSinceLastSubmit ||
            uploadInProgress ||
            submitInProgress;

          return (
            <>
              <Form
                className={classes}
                onSubmit={e => {
                  this.submittedValues = values;
                  handleSubmit(e);
                }}
              >
                <div className={css.sectionContainer}>
                  <Field
                    accept={ACCEPT_IMAGES}
                    id="profileImage"
                    name="profileImage"
                    label={chooseAvatarLabel}
                    type="file"
                    form={null}
                    uploadImageError={uploadImageError}
                    disabled={uploadInProgress}
                  >
                    {fieldProps => {
                      const { accept, id, input, label, disabled, uploadImageError } = fieldProps;

                      const { name, type } = input;
                      const onChange = e => {
                        const file = e.target.files[0];
                        form.change(`profileImage`, file);
                        form.blur(`profileImage`);
                        if (file != null) {
                          const tempId = `${file.name}_${Date.now()}`;
                          onImageUpload({ id: tempId, file });
                        }
                        e.target.value = '';
                        if (!/safari/i.test(navigator.userAgent)) {
                          e.target.type = '';
                          e.target.type = 'file';
                        }
                      };

                      let error = null;

                      if (isUploadImageOverLimitError(uploadImageError)) {
                        error = (
                          <div className={css.error}>
                            <FormattedMessage id="ProfileSettingsForm.imageUploadFailedFileTooLarge" />
                          </div>
                        );
                      } else if (uploadImageError) {
                        error = (
                          <div className={css.error}>
                            <FormattedMessage id="ProfileSettingsForm.imageUploadFailed" />
                          </div>
                        );
                      }

                      return (
                        <div className={css.uploadAvatarWrapper}>
                          <label className={css.label} htmlFor={id}>
                            {label}
                          </label>

                          <div className={css.uploadContainer}>
                            {profileImage.imageId || fileUploadInProgress ? (
                              <p className={css.uploadRemoveDiv}>
                                <label className={css.uploadRemoveLabel} htmlFor={id}>
                                  <FormattedMessage id="ProfileSettingsForm.changeAvatar" />
                                </label>

                                <button
                                  className={css.removeButton}
                                  type="button"
                                  onClick={() =>
                                    onUpdateProfile({
                                      profileImageId: null,
                                    }).then(() => {
                                      setRemove(false);
                                    })
                                  }
                                >
                                  <FormattedMessage id="ProfileSettingsForm.removeText" />
                                </button>
                              </p>
                            ) : (
                              <p className={css.uploadRemoveDiv}>
                                <label className={css.uploadRemoveLabel} htmlFor={id}>
                                  <FormattedMessage id="ProfileSettingsForm.uploadText" />
                                </label>
                                {/* <FormattedMessage id="ProfileSettingsForm.logoNameText" /> */}
                              </p>
                            )}

                            <div className={css.tip}>
                              <FormattedMessage id="ProfileSettingsForm.tip" />
                            </div>
                            <div className={css.fileInfo}>
                              <FormattedMessage id="ProfileSettingsForm.fileInfo" />
                            </div>
                            {error}
                          </div>

                          <input
                            accept={accept}
                            id={id}
                            name={name}
                            className={css.uploadAvatarInput}
                            disabled={disabled}
                            onChange={onChange}
                            type={type}
                          />
                        </div>
                      );
                    }}
                  </Field>
                </div>
                <div className={css.sectionContainer}>
                  <div className={css.nameContainer}>
                    {isProfileVerified ? (
                      <FieldDisabledInput
                        value={firstName}
                        id="firstName"
                        name="firstName"
                        label={<span className={css.verifyEmailText}>{firstNameLabel}</span>}
                        showButton={false}
                      />
                    ) : (
                      <FieldTextInput
                        className={textfield}
                        errorClassName={errorTextField}
                        type="text"
                        id="firstName"
                        name="firstName"
                        autoComplete="given-name"
                        label={firstNameLabel}
                        placeholder={firstNamePlaceholder}
                        validate={firstNameRequired}
                      />
                    )}
                    {isProfileVerified ? (
                      <FieldDisabledInput
                        value={lastName}
                        id="lastName"
                        name="lastName"
                        label={<span className={css.verifyEmailText}>{lastNameLabel}</span>}
                        showButton={false}
                      />
                    ) : (
                      <FieldTextInput
                        className={textfield}
                        errorClassName={errorTextField}
                        type="text"
                        id="lastName"
                        name="lastName"
                        label={lastNameLabel}
                        placeholder={lastNamePlaceholder}
                        validate={lastNameRequired}
                      />
                    )}
                  </div>
                  <div className={css.emailPhoneContainer}>
                    <FieldDisabledInput
                      value={email}
                      id={'email'}
                      name="email"
                      // label={emailLabel}
                      label={
                        <span className={css.verifyEmailText}>
                          {emailLabel}
                          <p>{emailVerifiedInfo}</p>
                        </span>
                      }
                      buttonLabel={<EditIcon />}
                      onClick={() => setShowEmailChangeModal(true)}
                      showButton={true}
                      iconClassName={css.editIcon}
                    />

                    {/* <FieldTextInput
                      className={textfield}
                      errorClassName={errorTextField}
                      type="email"
                      id={'email'}
                      name="email"
                      autoComplete="email"
                      label={
                        <span>
                          {emailLabel}
                          <p>{emailVerifiedInfo}</p>
                        </span>
                      }
                      placeholder={emailPlaceholder}
                      validate={emailValidator}
                    /> */}
                    <div className={css.PhoneField}>
                      <p>{phoneNumberLabel}</p>
                      <FieldPhoneNumberInputWithDialCode
                        name="phoneNumber"
                        id={'phoneNumber'}
                        // label={
                        //   <span className={css.verifyEmailText}>

                        // </span>
                        // }
                        placeholder={phoneNumberPlaceholder}
                        validate={phoneNumberRequired}
                        className={textfield}
                        errorClassName={errorTextField}
                      />
                    </div>
                  </div>

                  <div className={css.workerAddress}>
                    <FieldAddress
                      id={'workerAddress'}
                      name="workerAddress"
                      addressLabel={addressLabel}
                      addressPlaceholder={addressPlaceholder}
                      postalLabel={postalLabel}
                      postalPlaceholder={postalPlaceholder}
                      className={textfield}
                      errorClassName={errorTextField}
                      validate={addressRequired}
                      userNativeLang={userNativeLang}
                    />
                  </div>
                </div>
                {/* <FieldPerferredLang
                  id={'preferredLang'}
                  userNativeLang={userNativeLang}
                  name="preferredLang"
                  className={classNames(textfield, css.prefLang)}
                  errorClassName={errorTextField}
                /> */}
                {/* <FieldWorkerJobCategory
                  formApi={form}
                  id={'jobCategory'}
                  name="jobCategories"
                  userNativeLang={userNativeLang}
                  titleClassName={css.workerJobCategoryTitle}
                  values={jobCategories}
                  isRequired={true}
                /> */}

                {/*<h3 className={css.header}>
                {intl.formatMessage({ id: 'SignupForm.supportingDocHeader' })}
        </h3>*/}
                <div className={css.allowedOption}>
                  <div className={css.text}>
                    {intl.formatMessage({
                      id: 'SignupForm.allowedWorkerLabel',
                    })}
                  </div>
                  <CustomRadioButton
                    name="workerAllowed"
                    // onChange={this.handleWorkerAllowedChange}
                    radioValues={Object.values(workerAllowedOptions)}
                    id={'workerAllowed'}
                    withForm={false}
                    formClassName={css.option}
                    values={values}
                    radioSelectedInputClassName={classNames({
                      [css.notAllowedOption]: workerAllowed === workerAllowedOptions.no.value,
                    })}
                    disabled
                  />
                </div>
                <div className={classNames(css.allowedOption, css.columnOption)}>
                  <div className={css.optionContent}>
                    <div className={css.text}>
                      {intl.formatMessage({
                        id: 'SignupForm.birthDateLabel',
                      })}
                    </div>
                    <CustomRadioButton
                      name="age16Plus"
                      // onChange={this.handleAge16PlusChange}
                      radioValues={Object.values(age16PlusOptions)}
                      id={'age16PlusOptionsId'}
                      withForm={false}
                      formClassName={css.option}
                      values={values}
                      radioSelectedInputClassName={classNames({
                        [css.notAllowedOption]: age16Plus === age16PlusOptions.no.value,
                      })}
                      disabled
                    />
                  </div>
                  {/* {age16Plus === age16PlusOptions.yes.value && (
                    <FieldDateInput
                      name="birthdate"
                      id={'birthdateId'}
                      placeholderText={birthdatePlaceholder}
                      label={birthdateLabel}
                      validate={birthdateValidator}
                      className={textfield}
                      errorClassName={errorTextField}
                      isOutsideRange={date => moment().diff(date, 'days') <= 0}
                      displayFormat="DD/MM/YYYY"
                      userNativeLang={userNativeLang}
                    />
                  )} */}
                </div>
                <div className={css.allowedOption}>
                  <div className={css.text}>
                    {intl.formatMessage({
                      id: 'SignupForm.drivingLicenseLabel',
                    })}
                  </div>
                  <CustomRadioButton
                    name="drivingLicense"
                    onChange={this.handleDrivingLicenseChange}
                    radioValues={Object.values(drivingLicenseOptions)}
                    id={'drivingLicense'}
                    withForm={false}
                    formClassName={css.option}
                    values={values}
                    radioSelectedInputClassName={classNames({
                      [css.notAllowedOption]: drivingLicense === drivingLicenseOptions.no.value,
                    })}
                  />
                </div>
                <div className={css.WorkerAgreement}>
                  <FieldCheckbox
                    name="workerAgrement"
                    id={'workerAgreementId'}
                    label={workerAgrementLabel}
                    value={workagredOnTerms}
                    className={textfield}
                    disabled
                  />
                </div>
                {submitError}

                <div className={css.btncomp}>
                  <div className={css.submitcomp}>
                    {/* <Button
                      className={css.submitButton}
                      type="submit"
                      inProgress={submitInProgress}
                      disabled={submitDisabled}
                      ready={pristineSinceLastSubmit}
                    >
                      <FormattedMessage id="ProfileSettingsForm.saveChanges" />
                    </Button> */}
                    <Button
                      className={css.submitButton}
                      type="submit"
                      inProgress={submitInProgress}
                      disabled={submitDisabled}
                      ready={pristineSinceLastSubmit}
                    >
                      <FormattedMessage id="ProfileSettingsForm.saveChanges" />
                    </Button>
                  </div>

                  {/* <NamedLink name="ProfileSettingsPage" className={css.cancelbtn}>
                    <FormattedMessage id="ProfileSettingsForm.Cancel" />
                  </NamedLink> */}
                  <div
                    // type="button"
                    onClick={() => {
                      if (profileImage?.imageId !== null && !pristine) {
                        onUpdateProfile({
                          profileImageId: null,
                        });
                      }
                      form.reset();
                      history.replace(
                        createResourceLocatorString(
                          'ProfileSettingsPage',
                          routeConfiguration(),
                          {},
                          {}
                        )
                      );
                    }}
                  >
                    <FormattedMessage id="ProfileSettingsForm.Cancel" />
                  </div>
                </div>
              </Form>
              <ChangeEmailModal
                saveEmailError={saveEmailError}
                showEmailChangeModal={showEmailChangeModal}
                setShowEmailChangeModal={setShowEmailChangeModal}
                onManageDisableScrolling={onManageDisableScrolling}
                intl={intl}
                currentUser={currentUser}
                initialValues={{ currentEmail: initialValues.email }}
                onSubmitContactDetails={onSubmitContactDetails}
                sendVerificationEmailError={sendVerificationEmailError}
              />
            </>
          );
        }}
      />
    );
  }
}

WorkerProfileSettingsFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  uploadImageError: null,
  updateProfileError: null,
  updateProfileReady: false,
};

WorkerProfileSettingsFormComponent.propTypes = {
  rootClassName: string,
  className: string,

  uploadImageError: propTypes.error,
  uploadInProgress: bool.isRequired,
  updateInProgress: bool.isRequired,
  updateProfileError: propTypes.error,
  updateProfileReady: bool,

  // from injectIntl
  intl: intlShape.isRequired,
};

const WorkerProfileSettingsForm = compose(injectIntl)(WorkerProfileSettingsFormComponent);

WorkerProfileSettingsForm.displayName = 'WorkerProfileSettingsForm';

export default WorkerProfileSettingsForm;
